var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMicOff = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0049 14.8659C12.4627 14.8659 12.8895 14.7906 13.277 14.6495L8.44375 9.82243V11.0192C8.44375 13.2762 9.89168 14.8659 12.0049 14.8659Z",
    fill: "#878793"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1862 14.1442C14.1863 14.1442 14.1862 14.1442 14.1862 14.1442L15.6939 15.6497C15.6939 15.6497 15.694 15.6496 15.6939 15.6497L16.7115 16.6662C16.7116 16.6662 16.7115 16.6663 16.7115 16.6662L19.2517 19.2029C19.5461 19.4973 20.027 19.4973 20.3214 19.2029C20.606 18.8987 20.6158 18.4277 20.3214 18.1333L5.14053 2.96225C4.84614 2.67767 4.35548 2.66785 4.06109 2.96225C3.77651 3.25664 3.77651 3.74729 4.06109 4.03187L14.1862 14.1442Z",
    fill: "#878793"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0049 16.8776C13.0867 16.8776 14.0458 16.6457 14.8484 16.2189L15.8861 17.2552C14.9868 17.7938 13.9237 18.1322 12.7386 18.2318V20.5182H16.3683C16.7792 20.5182 17.1118 20.8519 17.1118 21.264C17.1118 21.6762 16.7792 22 16.3683 22H7.63173C7.22082 22 6.88819 21.6762 6.88819 21.264C6.88819 20.8519 7.22082 20.5182 7.63173 20.5182H11.2614V18.2318C7.53389 17.9178 5 15.229 5 11.3724V9.38037C5 8.96822 5.32285 8.64439 5.73375 8.64439C6.15444 8.64439 6.47729 8.96822 6.47729 9.38037V11.3136C6.47729 14.6598 8.6492 16.8776 12.0049 16.8776Z",
    fill: "#878793"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11.3724C19 12.6039 18.7426 13.7163 18.2706 14.6703L17.1482 13.5486C17.393 12.8816 17.5227 12.1313 17.5227 11.3136V9.38037C17.5227 8.96822 17.8553 8.64439 18.2662 8.64439C18.6771 8.64439 19 8.96822 19 9.38037V11.3724Z",
    fill: "#878793"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5563 11.0192C15.5563 11.3196 15.5306 11.6081 15.4812 11.8827L8.44375 4.84983V4.84673C8.44375 2.57991 9.89168 1 12.0049 1C14.1083 1 15.5563 2.57991 15.5563 4.84673V11.0192Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMicOff);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-mic-off.35ccd0473d7eb365a8fd63f6dba1d816.svg";